import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpResponse,
  HttpUserEvent
} from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';  // Import your AuthService
import { MatDialogComponent } from '../components/dialog-box/mat-dialog/mat-dialog.component';
import { LoaderService } from '../service/loader.service';
import { RestService } from '../service/rest.service';
import { CommonService } from '../service/common.service';
import { TokenStorage } from './token-storage';
 
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenAttempts = 0;
  private refreshSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private popupDisplayed = false;
  accessCode:any;
  domainId:any;
  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
    private router: Router,
    private loader: LoaderService,
    private restService: RestService,
    private token: TokenStorage,
    private commonService: CommonService
  ) {
  }
 
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    let pageReloaded = false;
 
    // Extract the domainId from the URL
    localStorage.removeItem('reqID');
    const url = window.location.href;
    this.domainId = this.extractDomainIdFromUrl(url);
    localStorage.setItem('reqID',this.domainId)
    return next.handle(this.addTokenAndDomainToRequest(req, this.domainId)).pipe(
      // catchError((error: HttpErrorResponse) => {
      //   if (error.status === 401) {
      //     if (!this.refreshTokenInProgress && this.refreshTokenAttempts === 0 && !this.dialog.openDialogs.length) {
      //       this.refreshTokenAttempts++;
      //       this.refreshTokenInProgress = true;
      //       this.refreshSubject.next(null);
 
      //       return this.authService.refreshToken().pipe(
      //         switchMap((response: any) => {
      //           if (response && response.rcode === 200) {
      //             //this.authService.saveToken(response.rObj.token);
      //             this.authService.saveRefreshToken(response.rObj.refreshToken);
      //             this.authService.b2cAttemptAuth(response.rObj.token);
      //             return next.handle(this.addTokenAndDomainToRequest(req, this.domainId, response.rObj.token));
      //           } else {
      //             this.handlePopupDisplay();
      //             return throwError('Token refresh failed');
      //           }
      //         }),
      //         catchError(() => this.handleRefreshTokenFailure())
      //       );
      //     } else {
      //       return this.refreshSubject.pipe(
      //         switchMap(() => next.handle(this.addTokenAndDomainToRequest(req, this.domainId)))
      //       );
      //     }
          
      //   } else if (error.status !== 401) {
      //     return this.handleNonError(error, req);
      //   } else {
      //     return throwError(error);
      //   }
      // })
    );
  }
 
  private extractDomainIdFromUrl(url: string): string | null {
    const urlObject = new URL(url);
    const domainId = urlObject.searchParams.get('domainId');
    return domainId;
  }
  triggerDomainProcessing(): void {
    // This method triggers the domainId extraction and subsequent processing
    const url = window.location.href;
    this.domainId = this.extractDomainIdFromUrl(url);
  }
 
  private addTokenAndDomainToRequest(req: HttpRequest<any>, domainId: string | null, token?: string): HttpRequest<any> {
    const headers: { [key: string]: string } = {};
 
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    if (domainId) {
      headers['orgappauthrequestid'] = domainId;
    }
    return req.clone({
      setHeaders: headers,
    });
  }
 
  private handleRefreshTokenFailure(): Observable<HttpEvent<any>> {
    this.handlePopupDisplay();
    return throwError('Token refresh failed');
  }
 
  private handleNonError(error: HttpErrorResponse, req: HttpRequest<any>): Observable<HttpEvent<any>> {
    switch (error.status) {
      case 404:
        this.loader.hide();
        this.dialog.closeAll();
        if (!req.url.endsWith('/login')) {
          this.router.navigate(['/error/error-status-404']);
        }
        return throwError(error);
      case 403:
        this.loader.hide();
        this.dialog.closeAll();
        this.router.navigate(['/error/error-status-403']);
        console.error('Forbidden Error:', error);
        return throwError(error);
      case 500:
        this.loader.hide();
        this.dialog.closeAll();
        if (error.error.transactionRef) {
          this.router.navigate(['/error/error-status-500', error.error.transactionRef]);
        } else {
          this.router.navigate(['/error/error-status-500']);
        }
        console.error('Internal Server Error:', error);
        return throwError(error);
      default:
        return throwError(error);
    }
  }
 
  private handlePopupDisplay(): void {
    if (!this.popupDisplayed && !this.dialog.openDialogs.length) {
      this.popupDisplayed = true;
      this.showPopupAndReload();
    }
  }
 
  private showPopupAndReload(): void {
    this.loader.hide();
    let _dialogRef = this.dialog.open(MatDialogComponent, {
      width: '50VW',
      disableClose: true,
      data: {
        tokenExpired: true,
        //errorMessage: this.translate.instant('Your session has expired. Please log in again to continue.')
      }
    });
 
    _dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.popupDisplayed = false;
        // this.router.navigate(['/auth/login']).then(() => {
        //   this.loader.hide();
        //   window.location.reload();
        // });
        const reqID = localStorage.getItem('reqID');
        localStorage.clear();
        const queryParams = {
        };
        if (reqID) {
          queryParams['domainId'] = reqID;
        }
        this.router.navigate(['/auth/login'], { queryParams }).then(() => {
          this.loader.hide();
          window.location.reload();
        });
      }
    });
  }
 
 
}
